import { useConfigHelper } from '@ilteducation/config';
import {
  OrganizationsResponseBody,
  GroupsResponseBody,
  MeResponseBody,
  UpdateMeRequest,
  UpdateMeResponse,
} from '@ilteducation/my-account-types';
import axios, { AxiosPromise, AxiosStatic } from 'axios';

const { getApiUrl } = useConfigHelper();
export const getMe = async (): Promise<MeResponseBody> => {
  const response = await axios.get<MeResponseBody>(`${getApiUrl('my-account', false)}/me`);

  return response.data;
};

export const getMyOrganizations = async (limit: number, offset: number): Promise<OrganizationsResponseBody> => {
  const response = await axios.get<OrganizationsResponseBody>(`${getApiUrl('my-account', false)}/me/organizations`, {
    params: {
      limit,
      offset,
    },
  });

  return response.data;
};

export const getMyGroups = async (limit: number, offset: number): Promise<GroupsResponseBody> => {
  const response = await axios.get<GroupsResponseBody>(`${getApiUrl('my-account', false)}/me/groups`, {
    params: {
      limit,
      offset,
    },
  });

  return response.data;
};

export const updateMe = async (params: UpdateMeRequest, appAxios?: AxiosStatic): AxiosPromise<UpdateMeResponse> => {
  const response = await (appAxios ?? axios).post<UpdateMeResponse>(`${getApiUrl('my-account', false)}/me`, params);

  return response;
};
